import { render } from "./MBPButton.vue?vue&type=template&id=7771172c&scoped=true"
import script from "./MBPButton.vue?vue&type=script&lang=js"
export * from "./MBPButton.vue?vue&type=script&lang=js"

import "./MBPButton.vue?vue&type=style&index=0&id=7771172c&scoped=true&lang=scss"

import exportComponent from "/var/www/eztrade-client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7771172c"]])

export default __exports__